module.exports = __webpack_public_path__ + "static/media/buffaloPlunker.b7ba407a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logs/buffalo/buffaloPlunker.png
// module id = 715
// module chunks = 0